<button [id]="idVal" type="button" (click)="onClick.emit($event)" class="btn st-button-edit rounded-pill">
  <i class="bi bi-pencil-fill st-button-icon"></i>
    {{label}}
</button>
